<template>


  <div style="margin-top:20px"></div>

  <li v-if="dir != '/'" @click="backClick" style="padding: 12px; text-align: left;margin-bottom:-1px ;"
    class="list-group-item">
    <i style="font-size: 20px;" class="fa fa fa-reply"></i>
    <span style="display: inline-block; width: auto;margin-left:24px">

      <a style="font-size: 15px" href="javascript:;">
        ...
      </a>
    </span>
  </li>

  <div :key="index" v-for="(element, index) in FileList">

    <li v-if='element.isdir == 0 && element.filename' style="padding: 12px; text-align: left;margin-bottom:-1px ;"
      class="list-group-item">
      <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>

      <span style="display: inline-block; width: auto;margin-left:10px;white-space: nowrap;"
        @click="menushow = true; menuitem = element">
        {{ element.filename }}
      </span>

      <!-- <span style="margin: 0px 0px 0px 45px;
    width: 60px;
    display: inline-block;">
        <el-button type="primary" @click="DownloadClick(element)">
          {{ downloadText(element) }}
        </el-button>
      </span> -->
    </li>


    <li v-if='element.isdir == 1 && element.filename' style="padding: 12px; text-align: left;margin-bottom:-1px ;"
      class="list-group-item">
      <i style="font-size: 20px;" class="fa fa-folder-open"></i>

      <span style="display: inline-block; margin-left:20px">
        <a style="font-size: 15px" @click="previewClick(element)" href="javascript:;">
          {{ element.filename }}
        </a>
      </span>
    </li>


  </div>

  <el-dialog v-model="menushow" width="300px" :close-on-click-modal="ture" :fullscreen="false">
    <div class="menuItem" @click="previewClick(menuitem); menushow = false">
      <i class="fa fa-search"></i>
      {{ $t('preview') }}
    </div>

    <div class="menuItem" @click="DownloadClick(menuitem); menushow = false">
      <i class="fa fa-briefcase"></i>
      {{ downloadText(menuitem) }}
    </div>


  </el-dialog>

  <el-dialog v-model="uploadShow" :close-on-click-modal="false" :fullscreen="false">
    <el-row>
      <el-col :span="6"></el-col>
      <el-col :span="12">
        <el-input v-model="fileName" placeholder="请输入文件名">
          <template #prepend>文件名</template>
        </el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10"></el-col>
      <el-col :span="3">
        <el-checkbox v-model="canDownload" label="下载需审批" />
      </el-col>
    </el-row>
    <br />
    <el-row :gutter="10">
      <el-col :span="9"></el-col>
      <el-col :span="2">
        <el-button @click="upload2server" type="primary">确定</el-button>
      </el-col>

      <el-col :span="4">
        <el-button @click="uploadShow = false; canDownload = false;">取消</el-button>
      </el-col>
    </el-row>
  </el-dialog>

</template>

<script>
import { file } from "@babel/types";
import { userInfo } from "os";
import Swal from "sweetalert2";
import { GetAllFiles, UploadFile, DeleteFile, RequestDownload, AddDir } from "../common/httphelper";
import getRole from "../common/role";


const OSS = require("ali-oss")

const client = new OSS({
  // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
  region: "oss-cn-guangzhou",
  // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
  accessKeyId: "LTAItdKUSj0MOUTc",
  accessKeySecret: "LhqjeZY9lC4rpAStCEMAIir7v6kFhp",
  // 刷新临时访问凭证的时间间隔，单位为毫秒。
  refreshSTSTokenInterval: 300000,
  // 填写Bucket名称。
  bucket: "motinova-admin",
});

export default {
  components: {

  },
  data() {
    return {
      FileList: [],
      dir: '',
      uploadShow: false,
      fileName: '',
      canDownload: false,
      uploadFileUrl: '',
      Role: {},
      lastdir: [],
      menushow: false,
      menuitem: {}
    }
  },
  methods: {
    async UploadData(file) {
      try {
        Swal.fire({
          title: "上传中...",
          html: "请稍候...",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
        Swal.showLoading();
        // object表示上传到OSS的文件名称。
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        const r1 = await client.put(
          this.dir + Math.random().toString(36).substr(2) + file.file.name,
          file.file
        );
        this.uploadFileUrl = r1.url
        Swal.close();
        this.fileName = file.file.name
        this.uploadShow = true
      } catch (e) {
        console.error("error: %j", e);
      }
    },
    previewClick(item) {
      if (item.isdir == 1) {
        this.lastdir.push(this.dir);
        this.dir = this.dir + item.filename + "/";
        this.refreshList();
        return;
      }


      if (['xlxs', 'doc', 'docx', 'pptx'].filter(x => item.filename.endsWith(x)).length) {
        // let url = this.$router.resolve({
        //   path: 'PdfViewer', query: {
        //     url: window.btoa(item.fileurl)
        //   }
        // })

        window.open('https://view.officeapps.live.com/op/embed.aspx?src=' + (item.fileurl), '_blank')

        return;
      }

      window.open(
        item.fileurl
      );

      return;
    },

    backClick() {
      if (this.lastdir.length < 1) {
        this.$router.back()
      } else {
        this.dir = this.lastdir.pop()
        this.refreshList()
      }
    },

    async upload2server() {

      if (!this.fileName) {
        this.uploadShow = false
        await Swal.fire({
          icon: "error",
          title: "请填写文件名",
          showConfirmButton: false,
          timer: 3000,
        });
        this.uploadShow = true
        return;
      }

      UploadFile({
        filename: this.fileName,
        fileurl: this.uploadFileUrl,
        candownload: this.canDownload,
        prefix: this.dir,
      }).then(async (res) => {
        if (res.data) {
          this.uploadShow = false
          await Swal.fire({
            icon: "success",
            title: "上传成功",
            showConfirmButton: false,
            timer: 3000,
          });
          this.refreshList()
        } else {
          this.uploadShow = false
          await Swal.fire({
            icon: "error",
            title: "文件已存在！",
            showConfirmButton: false,
            timer: 3000,
          });
          this.uploadShow = true
        }
      })
    },

    async DeleteItem(item) {
      // 指定待删除的Object的名称。Object名称需填写不包含Bucket名称在内的Object的完整路径，例如exampledir/exampleobject.txt。
      await DeleteFile(item.id).then(async (res) => {
        if (res.data) {
          await Swal.fire({
            icon: "success",
            title: "已提交审批",
            showConfirmButton: false,
            timer: 3000,
          });
          this.refreshList();
        } else {
          await Swal.fire({
            icon: "warning",
            title: "请等待审批完成！",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });

    },
    async AddDirClick() {
      const { value: name } = await Swal.fire({
        title: "输入文件夹名",
        input: "text",
        inputPlaceholder: "文件夹名",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
        allowOutsideClick: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      });
      if (!name) {
        return;
      }
      AddDir({
        filename: name,
        isdir: 1,
        prefix: this.dir,
      }).then(async (res) => {
        if (res.data) {
          this.uploadShow = false
          await Swal.fire({
            icon: "success",
            title: "上传成功",
            showConfirmButton: false,
            timer: 3000,
          });
          this.refreshList()
        } else {
          this.uploadShow = false
          await Swal.fire({
            icon: "error",
            title: "文件夹已存在！",
            showConfirmButton: false,
            timer: 3000,
          });
          this.uploadShow = true
        }
      })
    },
    refreshList() {
      this.fileName = ''; this.canDownload = false;

      Swal.fire({
        title: "加载中...",
        html: "请稍候...",
        allowEscapeKey: false,
        allowOutsideClick: false,
      });
      Swal.showLoading();

      GetAllFiles(this.dir).then(res => {
        this.FileList = res.data
        Swal.close()
      })
    },
    DownloadClick(item) {
      if (item.candownload) {
        RequestDownload(item.id).then(res => {
          if (res.data == "allow") {

            Swal.fire({
              title: "加载中...",
              html: "请稍候...",
              allowEscapeKey: false,
              allowOutsideClick: false,
            });
            Swal.showLoading();

            fetch(item.fileurl, {
              method: 'GET'
            }).then(resp => resp.blob())
              .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = item.filename; // the filename you want
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                Swal.close()
              })
          }

          if (res.data == "requested") {
            Swal.fire({
              icon: "success",
              title: "已提交审批",
              showConfirmButton: false,
              timer: 3000,
            });
          }

          if (res.data == "requesting") {
            Swal.fire({
              icon: "warning",
              title: "请等待审批完成",
              showConfirmButton: false,
              timer: 3000,
            });
          }

        })
      } else {
        Swal.fire({
          title: "加载中...",
          html: "请稍候...",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
        Swal.showLoading();

        fetch(item.fileurl, {
          method: 'GET'
        }).then(resp => resp.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = item.filename; // the filename you want
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            Swal.close()
          })
      }
    },
    downloadText(item) {
      if (item.candownload) {
        if (!item.allow_download_user) {
          if (this.$i18n.locale == "中文") return "申请下载";
          return "Apply for download";
        }

        if (item.allow_download_user.includes(sessionStorage.getItem("id"))) {
          if (this.$i18n.locale == "中文") return "下载";
          return "Download";
        }
      }
      if (this.$i18n.locale == "中文") return "下载";
      return "Download";
    },
  },
  mounted() {
    this.dir = this.$route.query.catlog;
    this.refreshList()
    this.Role = getRole()
  }
}
</script>

<style scoped>
a {
  cursor: pointer;
}

.menuItem {
  height: 60px;
  width: 200px;
  line-height: 60px;
  color: black;
  margin: 40px;
  background-color: gainsboro;
}

.menuItem:hover {
  background-color: darkgray;
}
</style>